/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApplicationDetailDTO,
  ApplicationListItemDTOQueryResultDTO,
  ApproveApplicationDTO,
  OrganizationAdminApplicationGetApplicationsParams
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const organizationAdminApplicationGetApplications = (
    organizationId: number,
    params?: OrganizationAdminApplicationGetApplicationsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ApplicationListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/OrganizationAdminApplication`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getOrganizationAdminApplicationGetApplicationsQueryKey = (organizationId: number,
    params?: OrganizationAdminApplicationGetApplicationsParams,) => {
    return [`/api/organizations/${organizationId}/admin/OrganizationAdminApplication`, ...(params ? [params]: [])] as const;
    }

    
export const getOrganizationAdminApplicationGetApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: OrganizationAdminApplicationGetApplicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationAdminApplicationGetApplicationsQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>> = ({ signal }) => organizationAdminApplicationGetApplications(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationAdminApplicationGetApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>>
export type OrganizationAdminApplicationGetApplicationsQueryError = ErrorType<unknown>


export function useOrganizationAdminApplicationGetApplications<TData = Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  OrganizationAdminApplicationGetApplicationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>,
          TError,
          Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationAdminApplicationGetApplications<TData = Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: OrganizationAdminApplicationGetApplicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>,
          TError,
          Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationAdminApplicationGetApplications<TData = Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: OrganizationAdminApplicationGetApplicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationAdminApplicationGetApplications<TData = Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: OrganizationAdminApplicationGetApplicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationAdminApplicationGetApplications>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationAdminApplicationGetApplicationsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const organizationAdminApplicationGetApplicationDetail = (
    organizationId: number,
    applicationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ApplicationDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/OrganizationAdminApplication/${applicationId}`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationAdminApplicationGetApplicationDetailQueryKey = (organizationId: number,
    applicationId: number,) => {
    return [`/api/organizations/${organizationId}/admin/OrganizationAdminApplication/${applicationId}`] as const;
    }

    
export const getOrganizationAdminApplicationGetApplicationDetailQueryOptions = <TData = Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>, TError = ErrorType<unknown>>(organizationId: number,
    applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationAdminApplicationGetApplicationDetailQueryKey(organizationId,applicationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>> = ({ signal }) => organizationAdminApplicationGetApplicationDetail(organizationId,applicationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && applicationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationAdminApplicationGetApplicationDetailQueryResult = NonNullable<Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>>
export type OrganizationAdminApplicationGetApplicationDetailQueryError = ErrorType<unknown>


export function useOrganizationAdminApplicationGetApplicationDetail<TData = Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    applicationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>,
          TError,
          Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationAdminApplicationGetApplicationDetail<TData = Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>,
          TError,
          Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationAdminApplicationGetApplicationDetail<TData = Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationAdminApplicationGetApplicationDetail<TData = Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationAdminApplicationGetApplicationDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationAdminApplicationGetApplicationDetailQueryOptions(organizationId,applicationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const organizationAdminApplicationApproveApplication = (
    organizationId: number,
    applicationId: number,
    approveApplicationDTO: ApproveApplicationDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/OrganizationAdminApplication/${applicationId}/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: approveApplicationDTO, signal
    },
      );
    }
  


export const getOrganizationAdminApplicationApproveApplicationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationAdminApplicationApproveApplication>>, TError,{organizationId: number;applicationId: number;data: ApproveApplicationDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationAdminApplicationApproveApplication>>, TError,{organizationId: number;applicationId: number;data: ApproveApplicationDTO}, TContext> => {
    
const mutationKey = ['organizationAdminApplicationApproveApplication'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationAdminApplicationApproveApplication>>, {organizationId: number;applicationId: number;data: ApproveApplicationDTO}> = (props) => {
          const {organizationId,applicationId,data} = props ?? {};

          return  organizationAdminApplicationApproveApplication(organizationId,applicationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationAdminApplicationApproveApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof organizationAdminApplicationApproveApplication>>>
    export type OrganizationAdminApplicationApproveApplicationMutationBody = ApproveApplicationDTO
    export type OrganizationAdminApplicationApproveApplicationMutationError = ErrorType<unknown>

    export const useOrganizationAdminApplicationApproveApplication = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationAdminApplicationApproveApplication>>, TError,{organizationId: number;applicationId: number;data: ApproveApplicationDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationAdminApplicationApproveApplication>>,
        TError,
        {organizationId: number;applicationId: number;data: ApproveApplicationDTO},
        TContext
      > => {

      const mutationOptions = getOrganizationAdminApplicationApproveApplicationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const organizationAdminApplicationRejectApplication = (
    organizationId: number,
    applicationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/OrganizationAdminApplication/${applicationId}/reject`, method: 'POST', signal
    },
      );
    }
  


export const getOrganizationAdminApplicationRejectApplicationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationAdminApplicationRejectApplication>>, TError,{organizationId: number;applicationId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationAdminApplicationRejectApplication>>, TError,{organizationId: number;applicationId: number}, TContext> => {
    
const mutationKey = ['organizationAdminApplicationRejectApplication'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationAdminApplicationRejectApplication>>, {organizationId: number;applicationId: number}> = (props) => {
          const {organizationId,applicationId} = props ?? {};

          return  organizationAdminApplicationRejectApplication(organizationId,applicationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationAdminApplicationRejectApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof organizationAdminApplicationRejectApplication>>>
    
    export type OrganizationAdminApplicationRejectApplicationMutationError = ErrorType<unknown>

    export const useOrganizationAdminApplicationRejectApplication = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationAdminApplicationRejectApplication>>, TError,{organizationId: number;applicationId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationAdminApplicationRejectApplication>>,
        TError,
        {organizationId: number;applicationId: number},
        TContext
      > => {

      const mutationOptions = getOrganizationAdminApplicationRejectApplicationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    